// dependencies
import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// css
import css from "./InfoLabel.module.scss";

type InfoLabelProps = {
	label: string;
	title: string;
	content: string;
	xssBypass?: boolean;
};

const InfoLabel = ({ label, title, content, xssBypass = false }: InfoLabelProps) => (
	<div className={css.labelContainer}>
		<div className="primary-label">
			<label style={{ display: "inline-block" }}>{label}</label>
			<div className={css.tooltipBox}>
				<FontAwesomeIcon
					className="_py-advanced-title"
					icon={["fas", "info-circle"]}
					size="xs"
					data-xssbypass={xssBypass.toString()}
					data-tooltip={title}
					data-tipc={content}
				/>
			</div>
		</div>
	</div>
);

export default InfoLabel;
